import uuidv4 from 'uuid/v4';

import { handleRequest } from './base';

const walletQuery = () => {
  const query = new URLSearchParams(window.location.search);
  const wallet = query.get('wallet') || 0;
  return {
    wallet,
  };
};

const AccountRepo = {
  fetch: (business, accountID) => handleRequest({
    method: 'get',
    url: `/business/${business.id}/accounts/${accountID}`,
    params: walletQuery(),
  }),

  fetchCollection: (business) => handleRequest({
    method: 'get',
    url: `/business/${business.id}/accounts`,
    params: walletQuery(),
  }),

  createNew: ({ business: { id: businessId }, alias, product_id, id = uuidv4() }) => {
    const endpoint = `/business/${businessId}/accounts/${id}`;
    const body = {
      alias,
      product_id,
    };

    return handleRequest({
      method: 'put',
      url: endpoint,
      data: body,
    });
  },
};

export default AccountRepo;
